export const TabItems = [
  { label: "Quiz Zone", value: 0 },
  { label: "Rewards", value: 1 },
  { label: "Leaderboard", value: 2 },
];

export enum Tabs {
  Quiz,
  Rewards,
  Leaderboard,
}
